import React from 'react'

export interface ModalWrapperProps {
  isChecked: boolean
  id: number
  onChange: () => void
}

const Toggle: React.FC<ModalWrapperProps> = ({ isChecked, id, onChange }) => (
  <div key={id}>
    <label
      className="toggle-btn dashboard__sales-toggle"
      htmlFor={`spotify-toggle-${id}`}
    >
      <input
        className="toggle-btn__input"
        id={`spotify-toggle-${id}`}
        name="spotify"
        readOnly
        type="checkbox"
        checked={isChecked}
        onChange={onChange}
      />
      <span className="toggle-btn__input-label" />
    </label>
  </div>
)

export default Toggle
